import { h } from 'preact';

import Header from './header';

// Code-splitting is automated for `routes` directory

const App = () => (
	<div id="app">
		<Header />
	</div>
)

export default App;
